module.exports = __webpack_public_path__ + "img/introduce04.63d06bfc.png";